export const setPicSize = (picUrl: string, picWidth: number, picHeight: number)=> {
  if(!picUrl || typeof picUrl !== 'string') {
    return '';
  }
  let url = picUrl;
  if(/(p[0-9]\.itc\.cn)/.test(url)) {
      url = url.indexOf('w_') === -1 ?
          url.replace(/(p[0-9]\.itc\.cn)/, `$1/q_70,c_lfill,w_${picWidth},h_${picHeight},g_face`) :
          (url.indexOf('c_cut') !== -1 ?
              url.replace(/c_cut,x_[0-9]*,y_[0-9]*,((w_[0-9]*,h_[0-9]*)|(w_[0-9]*|h_[0-9]*))/, `q_70,c_lfill,w_${picWidth},h_${picHeight},g_face`) :
              url.replace(/(w_[0-9]*,h_[0-9]*)|(w_[0-9]*|h_[0-9]*)/, `w_${picWidth},h_${picHeight}`)
          );
  }else{
      const whiteList = ['5b0988e595225.cdn.sohucs.com', '29e5534ea20a8.cdn.sohucs.com', 'img.mp.itc.cn', 'img.mp.sohu.com'];
      for(const i of whiteList){
          if(url.includes(whiteList[i])){
              const reg = new RegExp(`(${whiteList[i]})`);
              url = url.indexOf('w_') === -1 ?
                  url.replace(reg, `$1/q_70,c_lfill,w_${picWidth},h_${picHeight},g_face`) :
                  (url.indexOf('c_cut') !== -1 ?
                      url.replace(/c_cut,x_[0-9]*,y_[0-9]*,((w_[0-9]*,h_[0-9]*)|(w_[0-9]*|h_[0-9]*))/, `q_70,c_lfill,w_${picWidth},h_${picHeight},g_face`) :
                      url.replace(/(w_[0-9]*,h_[0-9]*)|(w_[0-9]*|h_[0-9]*)/, `w_${picWidth},h_${picHeight}`)
                  );
          }
      }
  }
  return url;
};



// WEBPACK FOOTER //
// ./src/utils/img_cutter.ts